/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = [''];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL1VzZXJzL2phc3dhbnRkaGF5YWwvRGVza3RvcC9Qcm9qZWN0cy9zZW5pb3JKYWNrZXRzL3NyYy9hcHAvbGVmdC1qYWNrZXQvbGVmdC1qYWNrZXQuY29tcG9uZW50LmNzcy5zaGltLm5nc3R5bGUudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9Vc2Vycy9qYXN3YW50ZGhheWFsL0Rlc2t0b3AvUHJvamVjdHMvc2VuaW9ySmFja2V0cy9zcmMvYXBwL2xlZnQtamFja2V0L2xlZnQtamFja2V0LmNvbXBvbmVudC5jc3MiXSwic291cmNlc0NvbnRlbnQiOlsiICJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7OyJ9



// WEBPACK FOOTER //
// /Users/jaswantdhayal/Desktop/Projects/seniorJackets/src/$$_gendir/app/left-jacket/left-jacket.component.css.shim.ngstyle.ts